module.exports = __webpack_public_path__ + "img/artist-img-5.0cc6bae6.jpg";